
import consts from './consts'

function onInsertContainer (editor, model) {
  // console.log('row=', editor.BlockManager.get('row'))
  model.get('components').add('<div class="row"></div><div class="row"></div>')
}

function onInsertRow (editor, model) {
  model.get('components').add('<div class="col" data-child-element="basic"></div>')
}

function onInsertColumn (editor, model) {
  model.get('components').add({
    type: 'text',
    tagName: 'div',
    attributes: { 'data-child-element': 'basic' },
    content: consts.defDIVContent
  })
}

export default (editor, config = {}) => {
  // const imgSrcDefault = 'https://dummyimage.com/450x250/999/222'
  const imgSrcDefault = '//cn.wware.org/img/file1.jpg'

  const contexts = [
    { value: 'primary',
      name: '重要内容'
    }, { value: 'secondary',
      name: '副标题'
    }, { value: 'success',
      name: '执行成功'
    }, { value: 'info',
      name: '提示内容'
    }, { value: 'warning',
      name: '警告内容'
    }, { value: 'danger',
      name: '危险操作'
    }, { value: 'light',
      name: '浅色内容'
    }, { value: 'dark',
      name: '深色内容'
    }
  ]

  const contextsWWhite = contexts.concat([{ value: 'white',
    name: '白色内容'
  }])

  const sizes = {
    'lg': 'Large',
    'sm': 'Small'
  }

  const c = config
  let domc = editor.DomComponents
  let blocks = c.blocks
  let cats = c.blockCategories

  var defaultType = domc.getType('default')
  var defaultModel = defaultType.model
  var defaultView = defaultType.view

  var textType = domc.getType('text')
  var textModel = textType.model
  var textView = textType.view
  let defTextView = textView

  var linkType = domc.getType('link')
  var linkModel = linkType.model
  var linkView = linkType.view

  var imageType = domc.getType('image')
  var imageModel = imageType.model
  var imageView = imageType.view

  editor.on('component:add', function (model) {
    if (model.get('components').length > 0) {
      // 只处理没有孩子的情况。
      return
    }
    switch (model.get('type')) {
      case 'container':
        onInsertContainer(editor, model)
        break
      case 'row':
        onInsertRow(editor, model)
        break
      case 'column':
        onInsertColumn(editor, model)
        break
    }
  })

  // Rebuild the default component and add utility settings to it (border, bg, color, etc)
  if (cats.basic) {
    if (blocks.default) {
      const borderColorTrait = {
        name: 'border-color',
        type: 'class_select',
        options: [
          { value: '', name: '默认' },
          ...contextsWWhite.map(function (v) { return { value: 'border border-' + v.value, name: window.s.capitalize(v.name) } })
        ],
        label: '边框颜色'
      }
      const borderShapeTrait = {
        type: 'class_select',
        name: 'border-shape',
        options: [
          { value: '', name: '默认' },
          { value: 'rounded', name: '圆角' },
          { value: 'rounded-top', name: '左上圆角' },
          { value: 'rounded-right', name: '右上圆角' },
          { value: 'rounded-bottom', name: '右下圆角' },
          { value: 'rounded-left', name: '左下圆角' },
          { value: 'rounded-circle', name: '园形' },
          { value: 'rounded-0', name: '方形' }
        ],
        label: '边框形状'
      }
      let updateBorderTraits = function (collection, value) {
        if (!collection) {
          console.log('not found collection')
          return
        }
        let border = collection.findWhere({ 'name': 'border' })
        let idx = collection.indexOf(border)
        if (idx >= 0) {
          idx++
        }
        let borderColor = collection.where({ 'name': 'border-color' })
        let borderShape = collection.where({ 'name': 'border-shape' })
        // console.log('borderShape=', borderShape)
        switch (value) {
          case 'border-0':
          case '':
          case 'GJS_NO_CLASS':
            if (borderColor.length > 0) {
              collection.remove(borderColor)
            }
            if (borderShape.length > 0) {
              collection.remove(borderShape)
            }
            break
          default:
            if (borderColor.length === 0) {
              // console.log('try to add borderColor with idx=:', idx)
              collection.add(borderColorTrait, { at: idx })
              if (idx >= 0) {
                idx++
              }
            }
            if (borderColor.length === 0) {
              collection.add(borderShapeTrait, { at: idx })
            }
            break
        }
      }
      domc.addType('default', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            tagName: 'div',
            traits: [
              {
                type: 'class_select',
                name: 'border',
                options: [
                  { value: '', name: '默认' },
                  { value: 'border-0', name: '无边框' },
                  { value: 'border', name: '有边框' },
                  { value: 'border-top', name: '上边框' },
                  { value: 'border-right', name: '右边框' },
                  { value: 'border-bottom', name: '下边框' },
                  { value: 'border-left', name: '左边框' },
                  { value: 'border-top-0', name: '无上边框' },
                  { value: 'border-right-0', name: '无右边框' },
                  { value: 'border-bottom-0', name: '无下边框' },
                  { value: 'border-left-0', name: '无左边框' }
                ],
                onValueChanged: function (value) {
                  let collection = this.target.get('traits')
                  updateBorderTraits(collection, value)
                },
                onInputCrated: function () {
                  let value = $(this.inputEl).val()
                  if (!value) {
                    value = 'GJS_NO_CLASS'
                  }
                  let collection = this.target.get('traits')
                  updateBorderTraits(collection, value)
                },
                label: '边框'
              },
              {
                type: 'text',
                label: '元素ID',
                name: 'id',
                placeholder: 'my_element'
              },
              {
                type: 'hints_input',
                label: '提示',
                name: 'title',
                list: 'layerdatalist',
                attr: 'title',
                placeholder: '当鼠标悬停时显示文本或文本引用的层'
              },
              {
                type: 'text',
                label: '循环表达式',
                name: 'data-bind-foreach',
                placeholder: '填入js数组表达式，控制本元素循环'
              },
              {
                type: 'text',
                label: '内容表达式',
                name: 'data-bind-text',
                placeholder: '填入js表达式，控制本元素内容'
              },
              {
                type: 'text',
                label: '显隐表达式',
                name: 'data-bind-show',
                placeholder: '填入js表达式，控制本元素显示或隐藏'
              }
            ] // .concat(defaultModel.prototype.defaults.traits)
          }),
          init () {
            const classes = this.get('classes')
            classes.bind('add', this.classesChanged.bind(this))
            classes.bind('change', this.classesChanged.bind(this))
            classes.bind('remove', this.classesChanged.bind(this))
            this.init2()
          },
          /* BS comps use init2, not init */
          init2 () {},
          /* method where we can check if we should changeType */
          classesChanged () {},
          /* replace the comp with a copy of a different type */
          changeType (newType) {
            const coll = this.collection
            const at = coll.indexOf(this)
            const buttonOpts = {
              type: newType,
              style: this.getStyle(),
              attributes: this.getAttributes(),
              content: this.view.el.innerHTML
            }
            coll.remove(this)
            coll.add(buttonOpts, { at })
            this.destroy()
          }
        }),
        view: defaultView
      })
      defaultType = domc.getType('default')
      defaultModel = defaultType.model
      defaultView = defaultType.view
    }

    // Rebuild the text component and add display utility setting
    // @TODO text类型和div容器类型分离。
    if (blocks.text) {
      domc.addType('text', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': wwjs.i18n('DIV容器'),
            tagName: 'div',
            // draggable: '.col, .col *, [lj-type=frame], [lj-type=frame] *, td, td *, [data-wwtype=absolute], [data-wwtype=absolute] *',
            draggable: '[data-child-element]',
            droppable: true,
            editable: true,
            traits: [
              {
                type: 'class_select',
                options: [
                  { value: '', name: wwjs.i18n('默认') },
                  ...contextsWWhite.map(function (v) { return { value: 'text-' + v.value, name: window.s.capitalize(v.name) } })
                ],
                label: '文本颜色'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: '默认' },
                  ...contextsWWhite.map(function (v) { return { value: 'bg-value' + v, name: window.s.capitalize(v.name) } })
                ],
                label: '背景颜色'
              } ].concat(defaultModel.prototype.defaults.traits)
          })
        }, {
          /* isComponent(el) {
                if(el && el.dataset && el.dataset.bsText) {
                  return {type: 'text'};
                }
              } */
        }),
        view: textView.extend({
          onActive (e) {
            if (this.model.get('type') === 'text' && this.model.get('components').length > 0) {
              return
            }
            return defTextView.prototype.onActive.apply(this, arguments)
          }
          // disableEditing () {
          //   if (this.inDisableEditing) {
          //     return
          //   }
          //   this.inDisableEditing = true
          //   const model = this.model
          //   const rte = this.rte
          //
          //   console.log(this)
          //   console.log(this.getChildrenContainer().innerHTML)
          //
          //   if (rte && model.get('editable')) {
          //     rte.disable(this, this.activeRte)
          //     model.set('content', this.getChildrenContainer().innerHTML)
          //       .trigger('change:content', model)
          //   }
          //
          //   this.rteEnabled = 0
          //   this.inDisableEditing = false
          //   this.toggleEvents()
          // }
        })
      })
      textType = domc.getType('text')
      textModel = textType.model
      textView = textType.view
    }

    // Rebuild the link component with settings for collapse-control
    if (blocks.link) {
      domc.addType('link', {
        model: textModel.extend({
          defaults: Object.assign({}, textModel.prototype.defaults, {
            'custom-name': wwjs.i18n('链接'),
            tagName: 'a',
            draggable: '[data-child-element]',
            droppable: true,
            editable: true,
            traits: [
              {
                type: 'text',
                label: '目标地址',
                name: 'href',
                // @TODO: 根据目标地址的值，动态显示打开方式以及特殊触发.
                placeholder: 'https://cn.wware.org'
              },
              {
                type: 'select',
                options: [
                  { value: '', name: '当前窗口' },
                  { value: '_blank', name: '新窗口' }
                ],
                label: '打开方式',
                name: 'target'
              },
              {
                type: 'select',
                options: [
                  { value: '', name: '无' },
                  { value: 'button', name: '按钮' },
                  { value: 'collapse', name: '伸缩面板' },
                  { value: 'dropdown', name: '下拉面板' }
                ],
                label: '特殊触发',
                name: 'data-toggle',
                changeProp: 1
              }
            ].concat(textModel.prototype.defaults.traits)
          }),
          init2 () {
            // textModel.prototype.init.call(this);
            this.listenTo(this, 'change:data-toggle', this.setupToggle)
            this.listenTo(this, 'change:attributes', this.setupToggle) // for when href changes
          },
          setupToggle (a, b, options = {}) { // this should be in the dropdown comp and not the link comp
            if (options.ignore === true && options.force !== true) {
              return
            }
            console.log('setup toggle')
            const attrs = this.getAttributes()
            const href = attrs.href
            // old attributes are not removed from DOM even if deleted...
            delete attrs['data-toggle']
            delete attrs['aria-expanded']
            delete attrs['aria-controls']
            delete attrs['aria-haspopup']
            if (href && href.length > 0 && href.match(/^#/)) {
              // console.log('link has href')
              // find the el where id == link href
              const els = this.em.get('Editor').DomComponents.getWrapper().find(href)
              if (els.length > 0) {
                console.log('referenced el found')
                var el = els[0] // should only be one el with this ID
                const elAttrs = el.getAttributes()
                // delete el_attrs['aria-labelledby'];
                const elClasses = elAttrs.class
                if (elClasses) {
                  console.log('el has classes')
                  const elClassesList = elClasses.split(' ')
                  const intersection = window._.intersection(['collapse', 'dropdown-menu'], elClassesList)
                  if (intersection.length) {
                    console.log('link data-toggle matches el class')
                    switch (intersection[0]) {
                      case 'collapse':
                        attrs['data-toggle'] = 'collapse'
                        break
                    }
                    attrs['aria-expanded'] = elClassesList.includes('show')
                    if (intersection[0] === 'collapse') {
                      attrs['aria-controls'] = href.substring(1)
                    }
                  }
                }
              }
            }
            this.set('attributes', attrs, { ignore: true })
          },
          classesChanged (e) {
            console.log('classes changed')
            if (this.attributes.type === 'link') {
              if (this.attributes.classes.filter(function (klass) { return klass.id === 'btn' }).length > 0) {
                this.changeType('button')
              }
            }
          }
        }, {
          isComponent (el) {
            if (el && el.tagName && el.tagName === 'A') {
              return { type: 'link' }
            }
          }
        }),
        view: linkView
      })
      linkType = domc.getType('link')
      linkModel = linkType.model
      linkView = linkType.view
    }

    if (blocks.image) {
      domc.addType('image', {
        model: imageModel.extend({
          defaults: Object.assign({}, imageModel.prototype.defaults, {
            'custom-name': wwjs.i18n('图像'),
            tagName: 'img',
            resizable: 1,
            attributes: {
              src: imgSrcDefault
            },
            traits: [
              {
                type: 'text',
                label: '图像地址(URL)',
                name: 'src'
              },
              {
                type: 'text',
                label: '替代文字',
                name: 'alt'
              }
            ]// .concat(imageModel.prototype.defaults.traits)
          })
        }, {
          isComponent: function (el) {
            if (el && el.tagName === 'IMG') {
              return { type: 'image' }
            }
          }
        }),
        view: imageView
      })
      imageType = domc.getType('image')
      imageModel = imageType.model
      imageView = imageType.view
    }
  }

  // LAYOUT

  if (cats.layout) {
    // Container

    if (blocks.container) {
      domc.addType('container', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': wwjs.i18n('行列容器'),
            draggable: '#wrapper, [lj-type=frame], [data-wwtype=absolute]',
            tagName: 'div',
            droppable: true,
            copyable: false,
            traits: [
              {
                type: 'class_select',
                options: [
                  { value: 'container', name: 'Fixed' },
                  { value: 'container-fluid', name: 'Fluid' }
                ],
                label: 'Width'
              }
            ].concat(defaultModel.prototype.defaults.traits)
          })
        }, {
          isComponent (el) {
            if (el && el.classList && (el.classList.contains('container') || el.classList.contains('container-fluid'))) {
              return { type: 'container' }
            }
          }
        }),
        view: defaultView.extend({
          // onRender () {
          //   $(this.el).css('min-height', '100vh')
          //   if ($.isFunction(defaultView.onRender)) {
          //     defaultView.onRender.apply(this, arguments)
          //   }
          // },
          events: {
            // click: function () {
            //   // console.log('on click:', arguments)
            // },
            // dblclick: function () {
            //   // $(this.el).focus()
            //   // console.log('on dbclick:', arguments)
            // }
            // ,
            // focusout: function () {
            //   console.log('on focusout', arguments)
            // }
          }
        })
      })
    }

    // Row

    if (blocks.row) {
      domc.addType('row', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': wwjs.i18n('行'),
            tagName: 'div',
            draggable: '.container, .container-fluid, .col',
            droppable: true,
            traits: [
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'Yes' },
                  { value: 'no-gutters', name: 'No' }
                ],
                label: 'Gutters?'
              }
            ].concat(defaultModel.prototype.defaults.traits)
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('row')) {
              return { type: 'row' }
            }
          }
        }),
        view: defaultView.extend({
          // onRender () {
          //   $(this.el).css('min-height', '30vh')
          //   if ($.isFunction(defaultView.onRender)) {
          //     defaultView.onRender.apply(this, arguments)
          //   }
          // }
        })
      })
    }

    // Column & Column Break

    if (blocks.column) {
      domc.addType('column', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': wwjs.i18n('列'),
            draggable: '.row',
            droppable: true,
            traits: [
              {
                type: 'class_select',
                options: [
                  { value: 'col', name: 'Equal' },
                  { value: 'col-auto', name: 'Variable' },
                  ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (i) { return { value: 'col-' + i, name: i + '/12' } })
                ],
                label: 'XS Width'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  { value: 'col-sm', name: 'Equal' },
                  { value: 'col-sm-auto', name: 'Variable' },
                  ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (i) { return { value: 'col-sm-' + i, name: i + '/12' } })
                ],
                label: 'SM Width'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  { value: 'col-md', name: 'Equal' },
                  { value: 'col-md-auto', name: 'Variable' },
                  ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (i) { return { value: 'col-md-' + i, name: i + '/12' } })
                ],
                label: 'MD Width'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  { value: 'col-lg', name: 'Equal' },
                  { value: 'col-lg-auto', name: 'Variable' },
                  ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (i) { return { value: 'col-lg-' + i, name: i + '/12' } })
                ],
                label: 'LG Width'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  { value: 'col-xl', name: 'Equal' },
                  { value: 'col-xl-auto', name: 'Variable' },
                  ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (i) { return { value: 'col-xl-' + i, name: i + '/12' } })
                ],
                label: 'XL Width'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (i) { return { value: 'offset-' + i, name: i + '/12' } })
                ],
                label: 'XS Offset'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (i) { return { value: 'offset-sm-' + i, name: i + '/12' } })
                ],
                label: 'SM Offset'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (i) { return { value: 'offset-md-' + i, name: i + '/12' } })
                ],
                label: 'MD Offset'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (i) { return { value: 'offset-lg-' + i, name: i + '/12' } })
                ],
                label: 'LG Offset'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (i) { return { value: 'offset-xl-' + i, name: i + '/12' } })
                ],
                label: 'XL Offset'
              }
            ].concat(defaultModel.prototype.defaults.traits)
          })
        }, {
          isComponent (el) {
            let match = false
            if (el && el.classList) {
              el.classList.forEach(function (klass) {
                if (klass === 'col' || klass.match(/^col-/)) {
                  match = true
                }
              })
            }
            if (match) return { type: 'column' }
          }
        }),
        view: defaultView
      })

      domc.addType('column_break', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            draggable: '.row',
            'custom-name': wwjs.i18n('换行列'),
            tagName: 'div',
            classes: ['w-100']
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('w-100')) { // also check if parent is `.row`
              return { type: 'column_break' }
            }
          }
        }),
        view: defaultView
      })

      // Media object

      domc.addType('media_object', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': 'Media Object',
            tagName: 'div',
            classes: ['media']
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('media')) {
              return { type: 'media' }
            }
          }
        }),
        view: defaultView
      })

      domc.addType('media_body', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': 'Media Body',
            tagName: 'div',
            classes: ['media-body']
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('media-body')) {
              return { type: 'media_body' }
            }
          }
        }),
        view: defaultView
      })
    }
  }

  // Bootstrap COMPONENTS

  if (cats.components) {
    // Alert

    if (blocks.alert) {
      domc.addType('alert', {
        model: textModel.extend({
          defaults: Object.assign({}, textModel.prototype.defaults, {
            'custom-name': 'Alert',
            tagName: 'div',
            classes: ['alert'],
            traits: [
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  ...contexts.map(function (v) { return { value: 'alert-' + v, name: window.s.capitalize(v) } })
                ],
                label: 'Context'
              }
            ].concat(textModel.prototype.defaults.traits)
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('alert')) {
              return { type: 'alert' }
            }
          }
        }),
        view: textView
      })
    }

    // Badge

    if (blocks.badge) {
      domc.addType('badge', {
        model: textModel.extend({
          defaults: Object.assign({}, textModel.prototype.defaults, {
            'custom-name': 'Badge',
            tagName: 'span',
            classes: ['badge'],
            traits: [
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  ...contexts.map(function (v) { return { value: 'badge-' + v, name: window.s.capitalize(v) } })
                ],
                label: 'Context'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'Default' },
                  { value: 'badge-pill', name: 'Pill' }
                ],
                label: 'Shape'
              }
            ].concat(textModel.prototype.defaults.traits)
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('badge')) {
              return { type: 'badge' }
            }
          }
        }),
        view: textView
      })
    }

    // Button

    if (blocks.button) {
      domc.addType('button', {
        model: linkModel.extend({
          defaults: Object.assign({}, linkModel.prototype.defaults, {
            'custom-name': 'Button',
            attributes: {
              role: 'button'
            },
            classes: ['btn'],
            traits: [
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'None' },
                  ...contexts.map(function (v) { return { value: 'btn-' + v, name: window.s.capitalize(v) } }),
                  ...contexts.map(function (v) { return { value: 'btn-outline-' + v, name: window.s.capitalize(v) + ' (Outline)' } })
                ],
                label: 'Context'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'Default' },
                  ...Object.keys(sizes).map(function (k) { return { value: 'btn-' + k, name: sizes[k] } })
                ],
                label: 'Size'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'Inline' },
                  { value: 'btn-block', name: 'Block' }
                ],
                label: 'Width'
              }
            ].concat(linkModel.prototype.defaults.traits)
          }),
          /* init2() {
            linkModel.prototype.init2.call(this); // call parent init in this context.
          }, */
          afterChange (e) {
            if (this.attributes.type === 'button') {
              if (this.attributes.classes.filter(function (klass) { return klass.id === 'btn' }).length === 0) {
                this.changeType('link')
              }
            }
          }
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('btn')) {
              return { type: 'button' }
            }
          }
        }),
        view: linkView
      })
    }

    // Button group

    if (blocks.button_group) {
      domc.addType('button_group', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': 'Button Group',
            tagName: 'div',
            classes: ['btn-group'],
            droppable: '.btn',
            attributes: {
              role: 'group'
            },
            traits: [
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'Default' },
                  ...Object.keys(sizes).map(function (k) { return { value: 'btn-group-' + k, name: sizes[k] } })
                ],
                label: 'Size'
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: 'Horizontal' },
                  { value: 'btn-group-vertical', name: 'Vertical' }
                ],
                label: 'Size'
              },
              {
                type: 'Text',
                label: 'ARIA Label',
                name: 'aria-label',
                placeholder: 'A group of buttons'
              }
            ].concat(defaultModel.prototype.defaults.traits)
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('btn-group')) {
              return { type: 'button_group' }
            }
          }
        }),
        view: defaultView
      })
    }

    // Button toolbar

    if (blocks.button_toolbar) {
      domc.addType('button_toolbar', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': 'Button Toolbar',
            tagName: 'div',
            classes: ['btn-toolbar'],
            droppable: '.btn-group',
            attributes: {
              role: 'toolbar'
            },
            traits: [
              {
                type: 'Text',
                label: 'ARIA Label',
                name: 'aria-label',
                placeholder: 'A toolbar of button groups'
              }
            ].concat(defaultModel.prototype.defaults.traits)
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('btn-toolbar')) {
              return { type: 'button_toolbar' }
            }
          }
        }),
        view: defaultView
      })
    }

    // Card

    if (blocks.card) {
      domc.addType('card', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': 'Card',
            classes: ['card'],
            traits: [
              {
                type: 'checkbox',
                label: 'Image Top',
                name: 'card-img-top',
                changeProp: 1
              },
              {
                type: 'checkbox',
                label: 'Header',
                name: 'card-header',
                changeProp: 1
              },
              {
                type: 'checkbox',
                label: 'Image',
                name: 'card-img',
                changeProp: 1
              },
              {
                type: 'checkbox',
                label: 'Image Overlay',
                name: 'card-img-overlay',
                changeProp: 1
              },
              {
                type: 'checkbox',
                label: 'Body',
                name: 'card-body',
                changeProp: 1
              },
              {
                type: 'checkbox',
                label: 'Footer',
                name: 'card-footer',
                changeProp: 1
              },
              {
                type: 'checkbox',
                label: 'Image Bottom',
                name: 'card-img-bottom',
                changeProp: 1
              }
            ].concat(defaultModel.prototype.defaults.traits)
          }),
          init2 () {
            this.listenTo(this, 'change:card-img-top', this.cardImageTop)
            this.listenTo(this, 'change:card-header', this.cardHeader)
            this.listenTo(this, 'change:card-img', this.cardImage)
            this.listenTo(this, 'change:card-img-overlay', this.cardImageOverlay)
            this.listenTo(this, 'change:card-body', this.cardBody)
            this.listenTo(this, 'change:card-footer', this.cardFooter)
            this.listenTo(this, 'change:card-img-bottom', this.cardImageBottom)
            this.components().comparator = 'card-order'
            this.set('card-img-top', true)
            this.set('card-body', true)
          },
          cardImageTop () { this.createCardComponent('card-img-top') },
          cardHeader () { this.createCardComponent('card-header') },
          cardImage () { this.createCardComponent('card-img') },
          cardImageOverlay () { this.createCardComponent('card-img-overlay') },
          cardBody () { this.createCardComponent('card-body') },
          cardFooter () { this.createCardComponent('card-footer') },
          cardImageBottom () { this.createCardComponent('card-img-bottom') },
          createCardComponent (prop) {
            const state = this.get(prop)
            const type = prop.replace(/-/g, '_').replace(/img/g, 'image')
            let children = this.components()
            let existing = children.filter(function (comp) {
              return comp.attributes.type === type
            })[0] // should only be one of each.

            if (state && !existing) {
              var comp = children.add({
                type: type
              })
              let compChildren = comp.components()
              if (prop === 'card-header') {
                compChildren.add({
                  type: 'header',
                  tagName: 'h4',
                  style: { 'margin-bottom': '0px' },
                  content: 'Card Header'
                })
              }
              if (prop === 'card-img-overlay') {
                compChildren.add({
                  type: 'header',
                  tagName: 'h4',
                  classes: ['card-title'],
                  content: 'Card title'
                })
                compChildren.add({
                  type: 'text',
                  tagName: 'p',
                  classes: ['card-text'],
                  content: "Some quick example text to build on the card title and make up the bulk of the card's content."
                })
              }
              if (prop === 'card-body') {
                compChildren.add({
                  type: 'header',
                  tagName: 'h4',
                  classes: ['card-title'],
                  content: 'Card title'
                })
                compChildren.add({
                  type: 'header',
                  tagName: 'h6',
                  classes: ['card-subtitle', 'text-muted', 'mb-2'],
                  content: 'Card subtitle'
                })
                compChildren.add({
                  type: 'text',
                  tagName: 'p',
                  classes: ['card-text'],
                  content: "Some quick example text to build on the card title and make up the bulk of the card's content."
                })
                compChildren.add({
                  type: 'link',
                  classes: ['card-link'],
                  href: '#',
                  content: 'Card link'
                })
                compChildren.add({
                  type: 'link',
                  classes: ['card-link'],
                  href: '#',
                  content: 'Another link'
                })
              }
              this.order()
            } else if (!state) {
              existing.destroy()
            }
          },
          order () {

          }
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('card')) {
              return { type: 'card' }
            }
          }
        }),
        view: defaultView
      })

      domc.addType('card_image_top', {
        model: imageModel.extend({
          defaults: Object.assign({}, imageModel.prototype.defaults, {
            'custom-name': 'Card Image Top',
            classes: ['card-img-top'],
            'card-order': 1
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('card-img-top')) {
              return { type: 'card_image_top' }
            }
          }
        }),
        view: imageView
      })

      domc.addType('card_header', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': 'Card Header',
            classes: ['card-header'],
            'card-order': 2
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('card-header')) {
              return { type: 'card_header' }
            }
          }
        }),
        view: defaultView
      })

      domc.addType('card_image', {
        model: imageModel.extend({
          defaults: Object.assign({}, imageModel.prototype.defaults, {
            'custom-name': 'Card Image',
            classes: ['card-img'],
            'card-order': 3
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('card-img')) {
              return { type: 'card_image' }
            }
          }
        }),
        view: imageView
      })

      domc.addType('card_image_overlay', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': 'Card Image Overlay',
            classes: ['card-img-overlay'],
            'card-order': 4
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('card-img-overlay')) {
              return { type: 'card_image_overlay' }
            }
          }
        }),
        view: defaultView
      })

      domc.addType('card_body', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': 'Card Body',
            classes: ['card-body'],
            'card-order': 5
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('card-body')) {
              return { type: 'card_body' }
            }
          }
        }),
        view: defaultView
      })

      domc.addType('card_footer', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': 'Card Footer',
            classes: ['card-footer'],
            'card-order': 6
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('card-footer')) {
              return { type: 'card_footer' }
            }
          }
        }),
        view: defaultView
      })

      domc.addType('card_image_bottom', {
        model: imageModel.extend({
          defaults: Object.assign({}, imageModel.prototype.defaults, {
            'custom-name': 'Card Image Bottom',
            classes: ['card-img-bottom'],
            'card-order': 7
          })
        }, {
          isComponent (el) {
            if (el && el.classList && el.classList.contains('card-img-bottom')) {
              return { type: 'card_image_bottom' }
            }
          }
        }),
        view: imageView
      })

      domc.addType('card_container', {
        model: defaultModel.extend({
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            'custom-name': 'Card Container',
            classes: ['card-group'],
            droppable: '.card',
            traits: [
              {
                type: 'class_select',
                options: [
                  { value: 'card-group', name: 'Group' },
                  { value: 'card-deck', name: 'Deck' },
                  { value: 'card-columns', name: 'Columns' }
                ],
                label: 'Layout'
              }
            ].concat(defaultModel.prototype.defaults.traits)
          })
        }, {
          isComponent (el) {
            if (el && el.classList && window._.intersection(el.classList, ['card-group', 'card-deck', 'card-columns']).length) {
              return { type: 'card_container' }
            }
          }
        }),
        view: defaultView
      })
    }

    // Collapse

    if (blocks.collapse) {
      // loadCollapse(editor, config)
    }

    // Dropdown

    if (blocks.dropdown) {
      // loadDropdown(editor, config)
    }
  }

  // TYPOGRAPHY

  if (cats.typography) {
    // Header

    if (blocks.header) {
      domc.addType('header', {
        model: textModel.extend({
          defaults: Object.assign({}, textModel.prototype.defaults, {
            'custom-name': '标题',
            tagName: 'h1',
            traits: [
              {
                type: 'select',
                options: [
                  { value: 'h1', name: 'h1(最大)' },
                  { value: 'h2', name: 'h2' },
                  { value: 'h3', name: 'h3' },
                  { value: 'h4', name: 'h4' },
                  { value: 'h5', name: 'h5' },
                  { value: 'h6', name: 'h6(最小)' }
                ],
                label: '标准尺寸',
                name: 'tagName',
                changeProp: 1
              },
              {
                type: 'class_select',
                options: [
                  { value: '', name: '使用标准尺寸' },
                  { value: 'display-1', name: 'e1(最大)' },
                  { value: 'display-2', name: 'e2' },
                  { value: 'display-3', name: 'e3' },
                  { value: 'display-4', name: 'e4(最小)' }
                ],
                label: '扩展尺寸'
              }
            ].concat(textModel.prototype.defaults.traits)
          })

        }, {
          isComponent (el) {
            if (el && ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(el.tagName)) {
              return { type: 'header' }
            }
          }
        }),
        view: textView
      })
    }

    if (blocks.paragraph) {
      domc.addType('paragraph', {
        model: textModel.extend({
          defaults: Object.assign({}, textModel.prototype.defaults, {
            'custom-name': '文本段',
            tagName: 'p',
            traits: [
              {
                type: 'class_select',
                options: [
                  { value: '', name: '否' },
                  { value: 'lead', name: '是' }
                ],
                label: '引导语?'
              }
            ].concat(textModel.prototype.defaults.traits)
          })
        }, {
          isComponent (el) {
            if (el && el.tagName && el.tagName === 'P') {
              return { type: 'paragraph' }
            }
          }
        }),
        view: textView
      })
    }
  }

  // 扩展支持，无条件的扩展。
  if (cats.extension) {
    const tableBorderTrait = {
      name: 'table-border',
      type: 'class_select',
      options: [
        { value: '', name: '默认' },
        { value: 'table-bordered', name: '全边框' },
        { value: 'table-borderless', name: '无边框' }
      ],
      label: '边框风格'
    }
    const tableStripedTrait = {
      type: 'class_select',
      name: 'table-striped',
      options: [
        { value: '', name: '否' },
        { value: 'table-striped', name: '是' }
      ],
      label: '斑马线'
    }
    const tableHoverTrait = {
      type: 'class_select',
      name: 'table-hover',
      options: [
        { value: '', name: '否' },
        { value: 'table-hover', name: '是' }
      ],
      label: '鼠标提示'
    }
    const tableResponsiveTrait = {
      type: 'class_select',
      name: 'table-responsive',
      options: [
        { value: '', name: '否' },
        { value: 'table-responsive', name: '是' },
        { value: 'table-responsive-sm', name: '手机宽之上' },
        { value: 'table-responsive-md', name: 'PAD宽之上' },
        { value: 'table-responsive-lg', name: 'PC宽之上' }
      ],
      label: '自适应'
    }
    const tableSMTrait = {
      type: 'class_select',
      name: 'table-small',
      options: [
        { value: '', name: '否' },
        { value: 'table-sm', name: '是' }
      ],
      label: '紧凑风格'
    }
    const tableBGColorTrait = {
      name: 'table-color',
      type: 'class_select',
      options: [
        { value: '', name: '默认' },
        { value: 'table-active', name: '激活颜色' },
        ...contextsWWhite.map(function (v) { return { value: 'table-' + v.value, name: window.s.capitalize(v.name) } })
      ],
      label: '背景颜色'
    }

    let updateTableTraits = function (collection, value) {
      if (!collection) {
        console.log('not found collection')
        return
      }
      let ext = collection.findWhere({ 'name': 'table_extension' })
      let idx = collection.indexOf(ext)
      if (idx >= 0) {
        idx++
      }
      let tableBorder = collection.where({ 'name': 'table-border' })
      let tableStriped = collection.where({ 'name': 'table-striped' })
      let tableHover = collection.where({ 'name': 'table-hover' })
      let tableResponsive = collection.where({ 'name': 'table-responsive' })
      let tableSmall = collection.where({ 'name': 'table-small' })
      let tableColor = collection.where({ 'name': 'table-color' })
      // console.log('borderShape=', borderShape)
      switch (value) {
        case '':
        case 'GJS_NO_CLASS':
          if (tableBorder.length > 0) {
            collection.remove(tableBorder)
          }
          if (tableStriped.length > 0) {
            collection.remove(tableStriped)
          }
          if (tableHover.length > 0) {
            collection.remove(tableHover)
          }
          if (tableResponsive.length > 0) {
            collection.remove(tableResponsive)
          }
          if (tableSmall.length > 0) {
            collection.remove(tableSmall)
          }
          if (tableColor.length > 0) {
            collection.remove(tableColor)
          }
          break
        default:
          if (tableBorder.length === 0) {
            collection.add(tableBorderTrait, { at: idx })
            if (idx >= 0) idx++
          }
          if (tableStriped.length === 0) {
            collection.add(tableStripedTrait, { at: idx })
            if (idx >= 0) idx++
          }
          if (tableHover.length === 0) {
            collection.add(tableHoverTrait, { at: idx })
            if (idx >= 0) idx++
          }
          if (tableResponsive.length === 0) {
            collection.add(tableResponsiveTrait, { at: idx })
            if (idx >= 0) idx++
          }
          if (tableSmall.length === 0) {
            collection.add(tableSMTrait, { at: idx })
            if (idx >= 0) idx++
          }
          if (tableColor.length === 0) {
            collection.add(tableBGColorTrait, { at: idx })
            if (idx >= 0) idx++
          }
          break
      }
    }
    domc.addType('table', {
      model: defaultModel.extend({
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': '表格',
          type: 'table',
          draggable: '[data-child-element]',
          tagName: 'table',
          traits: [
            {
              type: 'class_select',
              options: [
                { value: '', name: '否' },
                { value: 'table', name: '是' }
              ],
              label: '扩展外观设置',
              name: 'table_extension',
              onValueChanged: function (value) {
                let collection = this.target.get('traits')
                updateTableTraits(collection, value)
              },
              onInputCrated: function () {
                let value = $(this.inputEl).val()
                if (!value) {
                  value = 'GJS_NO_CLASS'
                }
                let collection = this.target.get('traits')
                updateTableTraits(collection, value)
              }
            }
          ].concat(defaultModel.prototype.defaults.traits)
        })
      }, {
        isComponent (el) {
          if (el.tagName === 'TABLE') {
            return { type: 'table' }
          }
        }
      }),
      view: defaultView
    })

    domc.addType('cellrow', {
      model: defaultModel.extend({
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': '表行',
          type: 'cellrow',
          tagName: 'tr',
          draggable: ['thead', 'tbody', 'tfoot'],
          droppable: ['th', 'td'],
          traits: [
            {
              type: 'class_select',
              options: [
                { value: '', name: '否' },
                { value: 'lead', name: '是' }
              ],
              label: '引导语?'
            }
          ].concat(defaultModel.prototype.defaults.traits)
        }),
        initialize (o, opt) {
          defaultModel.prototype.initialize.apply(this, arguments)

          // Clean the row from non cell components
          const cells = []
          const components = this.get('components')
          components.each(model => model.is('cell') && cells.push(model))
          components.reset(cells)
        }
      }, {
        isComponent (el) {
          if (el.tagName === 'TR') {
            return { type: 'cellrow' }
          }
        }
      }),
      view: defaultView
    })

    domc.addType('tbody', {
      model: defaultModel.extend({
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': '表体',
          type: 'tbody',
          tagName: 'tbody',
          traits: [
            {
              type: 'class_select',
              options: [
                { value: '', name: '否' },
                { value: 'table', name: '是' }
              ],
              label: '扩展风格'
            }
          ].concat(defaultModel.prototype.defaults.traits)
        }),
        initialize (o, opt) {
          defaultModel.prototype.initialize.apply(this, arguments)
          const components = this.get('components')
          let columns = this.get('columns')
          let rows = this.get('rows')

          // Init components if empty
          if (!components.length) {
            const rowsToAdd = []

            while (rows--) {
              const columnsToAdd = []
              let clm = columns

              while (clm--) {
                columnsToAdd.push({
                  type: 'cell',
                  classes: ['cell']
                })
              }

              rowsToAdd.push({
                type: 'cellrow',
                classes: ['cellrow'],
                components: columnsToAdd
              })
            }

            components.add(rowsToAdd)
          }
        }
      }, {
        isComponent (el) {
          if (el.tagName === 'TBODY') {
            return { type: 'tbody' }
          }
        }
      }),
      view: defaultView
    })
    let tbodyType = domc.getType('tbody')
    let tbodyModel = tbodyType.model
    let tbodyView = tbodyType.view

    domc.addType('thead', {
      model: tbodyModel.extend({
        defaults: Object.assign({}, tbodyModel.prototype.defaults, {
          'custom-name': '表头',
          type: 'thead',
          tagName: 'thead',
          traits: [
            {
              type: 'class_select',
              options: [
                { value: '', name: '否' },
                { value: 'lead', name: '是' }
              ],
              label: '引导语?'
            }
          ].concat(defaultModel.prototype.defaults.traits)
        })
      }, {
        isComponent (el) {
          if (el.tagName === 'THEAD') {
            return { type: 'thead' }
          }
        }
      }),
      view: tbodyView
    })

    domc.addType('tfoot', {
      model: tbodyModel.extend({
        defaults: Object.assign({}, tbodyModel.prototype.defaults, {
          'custom-name': '表尾',
          type: 'tfoot',
          tagName: 'tfoot',
          traits: [
            {
              type: 'class_select',
              options: [
                { value: '', name: '否' },
                { value: 'table', name: '是' }
              ],
              label: '扩展风格'
            }
          ].concat(defaultModel.prototype.defaults.traits)
        })
      }, {
        isComponent (el) {
          if (el.tagName === 'TFOOT') {
            return { type: 'tfoot' }
          }
        }
      }),
      view: tbodyView
    })

    domc.addType('cell', {
      model: textModel.extend({
        defaults: Object.assign({}, textModel.prototype.defaults, {
          'custom-name': '单元格',
          type: 'cell',
          tagName: 'td',
          draggable: ['tr'],
          traits: [
            {
              type: 'class_select',
              options: [
                { value: '', name: '否' },
                { value: 'lead', name: '是' }
              ],
              label: '引导语?'
            }
          ].concat(textModel.prototype.defaults.traits)
        })
      }, {
        isComponent (el) {
          let result = ''
          const tag = el.tagName

          if (tag === 'TD' || tag === 'TH') {
            result = {
              type: 'cell',
              tagName: tag.toLowerCase()
            }
          }
          return result
        }
      }),
      view: textView
    })
  }
}
